import { render, staticRenderFns } from "./HongKongBoardTable.vue?vue&type=template&id=379cb915&scoped=true"
import script from "./HongKongBoardTable.vue?vue&type=script&lang=js"
export * from "./HongKongBoardTable.vue?vue&type=script&lang=js"
import style0 from "./HongKongBoardTable.vue?vue&type=style&index=0&id=379cb915&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379cb915",
  null
  
)

export default component.exports